import { Route, Routes } from "react-router-dom";
import { EntryViewerV2 } from "./components/entry-viewer/EntryViewerV2";
import { LogbookProvider } from "./context/logbookContext";
import EntriesBrowser from "./entries-browser";

const LogbookEntryIndex = () => {
	return (
		<LogbookProvider>
			<Routes>
				<Route path={""} element={<EntriesBrowser />}>
					<Route path=":EntryId" element={<EntryViewerV2 />}></Route>
				</Route>
			</Routes>
		</LogbookProvider>
	);
};

export default LogbookEntryIndex;
